const theme = {
	scroll: 0,
	scroll_disabled: false,
	scroll_direction: undefined,

	init: () => {
		theme.banner.init();
		theme.testimonials.init();
		theme.recommendations.init();
		theme.header.init();
		theme.filters.init();
		theme.dropdown.init();
		theme.quantity.init();
		theme.product_gallery.init();
		theme.product_dropdown.init();
		theme.product_description.init();
		theme.cart.init();
		theme.product_form.init();
		theme.search.init();
		theme.contact.init();
		theme.facials.init();
		theme.login.init();
		theme.register.init();
		theme.account.init();
		//theme.wishlist.init();
		theme.body_scroll.init();
		theme.animations.init();
		theme.searchSuggestionsPrices.init();
	},

	searchSuggestionsPrices: {
		init: () => {
			const events = ['input', 'focus', 'click'];
			const searchInput = document.querySelector('.boost-pfs-search-input');
			const searchPrettyInput = document.querySelector('.search__input');
			
			const suggestionsObserver = new MutationObserver((mutations_list) => {
				mutations_list.forEach((mutation) => {
					mutation.addedNodes.forEach((added_node) => {
						try {
							//Using W3 DOM2 (works for FF, Opera and Chrome)
							if (added_node instanceof HTMLElement) {
								if (added_node.classList.contains('boost-pfs-search-suggestion-groups-pro')) {
									added_node.querySelectorAll('.boost-pfs-search-suggestion-item').forEach(item => {
										// console.log(item.querySelector('.boost-pfs-search-suggestion-product-vendor'));
										// const vendor = item.querySelector('.boost-pfs-search-suggestion-product-vendor');
										// const priceEl = item.querySelector('.boost-pfs-search-suggestion-product-price');
										
										// if (vendor) {
										// 	if (vendor.textContent == "Biologique Recherche" || vendor.textContent == "Biologique Recherché") {
										// 		priceEl.innerHTML = 'Login to shop';
										// 	}
										// }
									});
								}
							}
						}
						catch(e){
							console.log(e);
							//Browsers not supporting W3 DOM2 don't have HTMLElement and
							//an exception is thrown and we end up here. Testing some
							//properties that all elements have (works on IE7)
							suggestionsObserver.disconnect();
						}
					});
				});
			});
			
			if (!document.body.classList.contains('user-logged-in')) {
				suggestionsObserver.observe(document.body, { childList: true, subtree: true });
			} else {
				suggestionsObserver.disconnect();
			}
		}
	},

	banner: {
		instances: undefined,

		init: () => {
			theme.banner.instances = document.querySelectorAll('.banner__slider');

			theme.banner.instances.forEach(slider => {
				let has_dots = (slider.querySelectorAll('.banner__slide').length > 1) ? true : false;
				let flkty = new Flickity(slider, {
					cellSelector: '.banner__slide',
					prevNextButtons: false,
					pageDots: has_dots,
					autoPlay: 10000,
					pauseAutoPlayOnHover: false,
					on: {
						ready: () => {
							let dots = slider.querySelector('.flickity-page-dots');
							if(dots){
								let color = slider.querySelector('[data-index="1"]').getAttribute('data-color');
								if(color == 'dark'){
									dots.classList.add('dark');
								} else {
									dots.classList.remove('dark');
								}
							}
						}
					}
				});
				flkty.on('change', index => {
					let dots = slider.querySelector('.flickity-page-dots');
					if(dots){
						let i = index + 1,
							color = slider.querySelector('[data-index="'+i+'"]').getAttribute('data-color');
						if(color == 'dark'){
							dots.classList.add('dark');
						} else {
							dots.classList.remove('dark');
						}
					}
				});
			});
		}
	},

	testimonials: {
		instances: undefined,

		init: () => {
			theme.testimonials.instances = document.querySelectorAll('.testimonials__slider');

			theme.testimonials.instances.forEach(slider => {
				let flkty = new Flickity(slider, {
					cellSelector: '.testimonials__slide',
					cellAlign: 'left',
					contain: true,
					prevNextButtons: false,
					pageDots: true,
					pauseAutoPlayOnHover: false
				});
			});
		}
	},

	recommendations: {
		instance: undefined,
		slider: undefined,
		flkty: undefined,
		flkty_options: {},
		is_dektop: false,
		trigger_resize: true,
		url: false,

		init: () => {
			theme.recommendations.instance = document.querySelector('.product-recommendations');

			if(theme.recommendations.instance){
				theme.recommendations.url = theme.recommendations.instance.getAttribute('data-url');
				theme.recommendations.url = document.querySelector('.product-recommendations').getAttribute('data-url');
				theme.recommendations.slider = document.querySelector('.product-recommendations__slider');
				theme.recommendations.flkty_options = {
					cellSelector: '.product-recommendations__slide',
					cellAlign: 'center',
					initialIndex: 1,
					wrapAround: true,
					contain: true,
					prevNextButtons: false,
					pageDots: false,
					pauseAutoPlayOnHover: false
				};
				theme.recommendations.is_dektop = matchMedia('only screen and (min-width: 1200px)').matches;
				
				if(theme.recommendations.url){
					theme.recommendations.load();
				} else {
					theme.recommendations.flkty = new Flickity(theme.recommendations.slider, theme.recommendations.flkty_options);
					theme.recommendations.resize();
				}
			}
		},  

		resize: () => {
			if(theme.recommendations.instance){
				if(theme.recommendations.trigger_resize){
					theme.recommendations.is_dektop = matchMedia('only screen and (min-width: 1200px)').matches;

					if(theme.recommendations.is_dektop){
						theme.recommendations.flkty_options.cellAlign = 'left';
	  	 			theme.recommendations.flkty_options.wrapAround = false;
	  	 			theme.recommendations.flkty_options.initialIndex = 0;
					} else {
						theme.recommendations.flkty_options.cellAlign = 'center';
						theme.recommendations.flkty_options.wrapAround = true;
						theme.recommendations.flkty_options.initialIndex = 1;
					}
					if(theme.recommendations.flkty){
						theme.recommendations.flkty.destroy();
					}
					theme.recommendations.flkty = new Flickity(theme.recommendations.slider, theme.recommendations.flkty_options);
				}

				if(matchMedia('only screen and (min-width: 1200px)').matches !== theme.recommendations.is_dektop){
					theme.recommendations.trigger_resize = true;
				} else {
					theme.recommendations.trigger_resize = false;
				}
			}
		},

		load: () => {
			if(theme.recommendations.url){
				fetch(theme.recommendations.url).then(response => response.text()).then(text => {
			    const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('.product-recommendations').innerHTML;
          if(recommendations) {
            document.querySelector('.product-recommendations').innerHTML = recommendations;
          }
          theme.recommendations.slider = document.querySelector('.product-recommendations__slider');
			    theme.recommendations.flkty = new Flickity(theme.recommendations.slider, theme.recommendations.flkty_options);
			    theme.recommendations.resize();
			    theme.animations.wrap_buttons();
			  })
			  .catch(e => {
			    console.error(e);
			  });
			}
		}
	},

	header: {
		el: undefined,
		button: undefined,
		opened: false,
		drawer: undefined,
		collapse: undefined,

		init: () => {
			theme.header.el = document.querySelector('.header');
			theme.header.button = document.querySelector('.header [data-menu-open]');
			theme.header.drawer = document.querySelector('.header__drawer');
			theme.header.collapse = document.querySelectorAll('.header__drawer .link--collapse');

			theme.header.el.querySelectorAll('.header__menu > li').forEach(item => {
				item.addEventListener('mouseenter', event => {
					if(item.querySelector('ul')){
						theme.cart.close();
						theme.search.close();
						theme.header.el.classList.add('header--no-transparent');
					}
				});

				item.addEventListener('mouseleave', event => {
					theme.header.el.classList.remove('header--no-transparent');
				});
			});

			theme.header.el.addEventListener('click', event => {
				event.stopPropagation();
			});

			theme.header.button.addEventListener('click', event => {
				if(theme.header.opened){
					theme.header.close();
				} else {
					theme.header.open();
				}
			});

			if(theme.header.collapse){
				theme.header.collapse.forEach(link => {
					link.addEventListener('click', event => {
						event.preventDefault();
						link.classList.toggle('link--active');
						let list = link.parentNode.querySelector('ul');
						if(link.classList.contains('link--active')) {
					    list.style.display = "block";
					    setTimeout(() => {
					    	list.childNodes.forEach(subitem => {
						    	if(subitem.nodeType == 1){
						    		subitem.classList.add('show');
						    	}
						    });
					    });
					  } else {
					    list.style.display = "none";
					    list.querySelectorAll('li').forEach(subitem => {
					    	subitem.classList.remove('show');
					    });
					  }
					});
				});
			}
		},

		open: () => {
			if(!theme.header.opened){
				theme.cart.close();
				theme.body_scroll.disable();
				theme.header.drawer.classList.add('header__drawer--open');
				theme.header.el.classList.add('header--opened');
				theme.header.el.classList.add('header--no-transparent');
				theme.header.button.setAttribute('aria-expanded', true);
				theme.header.button.classList.add('header__button--active');
				theme.header.opened = true;
				setTimeout(() => {
					theme.header.drawer.querySelectorAll('.link--primary').forEach(item => {
			    	item.parentNode.classList.add('show');
			    });
				});
			}
		},

		close: () => {
			if(theme.header.opened){
				theme.body_scroll.enable();
				theme.header.drawer.classList.remove('header__drawer--open');
				theme.header.el.classList.remove('header--opened');
				theme.header.el.classList.remove('header--no-transparent');
				theme.header.button.setAttribute('aria-expanded', false);
				theme.header.button.classList.remove('header__button--active');
				theme.header.opened = false;
				theme.header.drawer.querySelectorAll('.link--primary').forEach(item => {
		    	item.parentNode.classList.remove('show');
		    });
			}
		},

		onScroll: () => {
			if(!theme.scroll_disabled){
				// if(theme.scroll_direction == 'down' && theme.scroll > 250){
				// 	theme.header.el.classList.add('header--hide');
				// } else {
				// 	theme.header.el.classList.remove('header--hide');
				// }

				if(theme.scroll > 30){
	 				theme.header.el.classList.add('header--flat');
				} else {
					theme.header.el.classList.remove('header--flat');
				}
			}
		}
	},

	dropdown: {
		instances: undefined,

		init: () => {
			theme.dropdown.instances = document.querySelectorAll('.dropdown');

			if(theme.dropdown.instances){
				document.querySelector('body').addEventListener('click', event => {
					theme.dropdown.instances.forEach(dropdown => {
						dropdown.classList.remove('dropdown--open');
					});
				});

				theme.dropdown.instances.forEach(dropdown => {
					dropdown.addEventListener('click', event => {
						event.stopPropagation();
						theme.dropdown.instances.forEach(other => {
							if(other !== dropdown){
								other.classList.remove('dropdown--open');
							}
						});
						dropdown.classList.toggle('dropdown--open');						
					});

					dropdown.querySelectorAll('li').forEach(item => {
						item.addEventListener('click', event => {
							event.stopPropagation();
							let value = item.getAttribute('data-value'),
									label = item.getAttribute('data-label') || event.target.innerHTML;
							dropdown.querySelector('input[type="hidden"]').value = value;
							dropdown.querySelector('input[type="text"]').value = label;
							dropdown.classList.remove('dropdown--open');
						});
					});
				});
			}
		}
	},

	quantity: {
		buttons: undefined,
		product_form: undefined,
		preorder: undefined,

		init: () => {
			theme.quantity.product_form = document.querySelector('form.product-form');
			theme.quantity.preorder = document.querySelector('form.product-form [data-preorder]');

			if(theme.quantity.product_form){
				theme.quantity.product_form.querySelector('.quantity__input').addEventListener('change', event => {
					let qty = parseInt(event.target.value);
					theme.quantity.product_form.querySelectorAll('[data-unit-price]').forEach(price => {
						let value = parseFloat(price.getAttribute('data-unit-price').replace(',','.')),	
								total = value * qty + ' €';
						price.innerHTML = theme.numberWithSpaces(total) + ' €';
					});
					if(theme.quantity.preorder){
						if(qty > parseInt(theme.quantity.preorder.getAttribute('data-preorder'))){
							theme.quantity.preorder.classList.remove('product-form__note--hidden');
						} else {
							theme.quantity.preorder.classList.add('product-form__note--hidden');
						}
					}
				});
			}

			theme.quantity.bind(true);
		},

		bind: (all) => {
			if(all){
				theme.quantity.buttons = document.querySelectorAll('[data-quantity-button]');				
			} else {
				theme.quantity.buttons = document.querySelectorAll('.cart--drawer [data-quantity-button]');
			}

			theme.quantity.buttons.forEach(button => {
				button.addEventListener('click', event => {
					event.preventDefault();
					let direction = button.getAttribute('data-quantity-button'),
							input = button.parentElement.querySelector('input'),
							value = parseInt(input.value),
							trigger = new Event('change');
					if(direction=='increase'){
						value++;
					} else {
						if(value>1){
							value--;
						} else {
							trigger = false;
						}
					}	
					input.value = value;
					if(trigger) input.dispatchEvent(trigger);
				});
			});
		}
	},

	filters: {
		el: undefined,
		price_range: undefined,
		price_from: undefined,
		price_to: undefined,
		dropdown: undefined,
		sort_reset: undefined,
		button_open: undefined,

		init: () => {
			theme.filters.el = document.querySelector('.filters');
			theme.filters.price_range = document.getElementById('price-range');
			theme.filters.price_from = document.getElementById('price-range-from');
			theme.filters.price_to = document.getElementById('price-range-to');
			theme.filters.dropdown = document.querySelectorAll('.filters__dropdown-button');
			theme.filters.sort_reset = document.querySelector('[data-reset-sort-by]');
			theme.filters.button_open = document.querySelector('[data-filters-open]');

			document.querySelector('body').addEventListener('click', event => {
				if(matchMedia('only screen and (min-width: 1200px)').matches){
					theme.filters.dropdown.forEach(button => {
						button.nextElementSibling.classList.remove('filters__dropdown--show');
					});
				}
			});

			theme.filters.dropdown.forEach(button => {
				if(button.nextElementSibling){
					button.nextElementSibling.addEventListener('click', event => {
						event.stopPropagation();
					});
				}					

				button.addEventListener('click', event => {
					event.stopPropagation();
					theme.filters.dropdown.forEach(other_button => {
						if(other_button.nextElementSibling){
							if(other_button !== button){
								other_button.nextElementSibling.classList.remove('filters__dropdown--show');
							}
						}
					});
					if(button.nextElementSibling){
						button.nextElementSibling.classList.toggle('filters__dropdown--show');
					}
				});
			});

			if(theme.filters.sort_reset){
				theme.filters.sort_reset.addEventListener('click', event => {
					document.querySelector('input[name="sort_by"]:checked').checked = false;
					document.querySelector('.filters__form').submit();
				});
			}

			if(theme.filters.price_range){
				let min = parseInt(theme.filters.price_range.getAttribute('data-min')),
						max = parseInt(theme.filters.price_range.getAttribute('data-max')),
						from = 0,
						to = max,
						tooltip_format = {
							decimals: 0
						}
				if(theme.filters.price_range.getAttribute('data-from')){
					from = parseInt(theme.filters.price_range.getAttribute('data-from'));
				}
				if(theme.filters.price_range.getAttribute('data-to')){
					to = parseInt(theme.filters.price_range.getAttribute('data-to'));
				}

				let price = noUiSlider.create(theme.filters.price_range, {
			    start: [from, to],
			    step: 10,
			    connect: true,
			    range: {
		        'min': min,
		        'max': max
				  },
				  tooltips: [
		        wNumb(tooltip_format),
		        wNumb(tooltip_format) 
			    ],
				});
				price.on('update', function (values, handle){
					let value = values[handle];
					if(handle==0){
						theme.filters.price_from.value = value;
					}
					if(handle==1){
						theme.filters.price_to.value = value;
					}
				});
				price.on('slide', function(){
					theme.filters.price_range.classList.remove('filters__price--blank');
				});
			}

			if(theme.filters.button_open){
				theme.filters.button_open.addEventListener('click', event => {
					let opened = (theme.filters.button_open.getAttribute('aria-expanded') == 'true') ? false : true;
					if(opened){
						theme.body_scroll.disable();
						theme.filters.el.classList.add('filters--opened');
					} else {
						theme.body_scroll.enable();
						theme.filters.el.classList.remove('filters--opened');
					}
					theme.filters.button_open.setAttribute('aria-expanded', opened);
				});
			}
		}
	},

	product_gallery: {
		container: undefined,
		slider: undefined,
		flkty: undefined,
		items: undefined,
		photo_swipe_container: undefined,
		photo_swipe: undefined,

		init: () => {
			theme.product_gallery.container = document.querySelector('.product-main__gallery');
			theme.product_gallery.slider = document.querySelector('.product-main__slider');
			theme.product_gallery.photo_swipe_container = document.querySelectorAll('.pswp')[0];

			if(theme.product_gallery.slider){
				let has_dots = (theme.product_gallery.slider.querySelectorAll('.product-main__media').length > 1) ? true : false,
						images = [];

				theme.product_gallery.flkty = new Flickity(theme.product_gallery.slider, {
					cellSelector: '.product-main__media',
					prevNextButtons: false,
					pageDots: has_dots
				});

        document.querySelectorAll('.product-main__media img').forEach(image => {
        	images.push(image);
        });	
        theme.product_gallery.items = theme.product_gallery.get_photo_swipe_items(images);

        document.querySelector('[data-zoom]').addEventListener('click', event => {
        	theme.product_gallery.photo_swipe = new PhotoSwipe(theme.product_gallery.photo_swipe_container, PhotoSwipeUI_Default, theme.product_gallery.items, {
	          index: theme.product_gallery.flkty.selectedIndex,
	          loop: false,
	          showHideOpacity: true,
	          history: false,
	          closeOnVerticalDrag: false,
	          closeOnScroll: false,
	          allowPanToNext: true,
	          pinchToClose: false,
	          initialZoomLevel: 2,
	          shareButtons: false
	        });

        	theme.product_gallery.photo_swipe.init();
        	theme.product_gallery.photo_swipe.applyZoomPan(1, (theme.product_gallery.photo_swipe.viewportSize.x-theme.product_gallery.photo_swipe.currItem.w)/2, 0);
        });

        document.querySelector('.pswp__btn--close').addEventListener('click', event => {
        	theme.product_gallery.photo_swipe.close();
        });

        if(document.querySelector('.pswp__btn--prev')){
        	document.querySelector('.pswp__btn--prev').addEventListener('click', event => {
	        	theme.product_gallery.photo_swipe.prev();
	        });
        }

        if(document.querySelector('.pswp__btn--next')){
        	document.querySelector('.pswp__btn--next').addEventListener('click', event => {
	        	theme.product_gallery.photo_swipe.next();
	        });
        }
			}
		},

		get_photo_swipe_items: (images) => {
			return images.map(function (image) {
        return {
          w: parseInt(image.getAttribute('width')),
          h: parseInt(image.getAttribute('height')),
          src: image.getAttribute('data-zoom-src'),
          initialZoomLevel: 2
        };
      });
		},

		onScroll: () => {
			if(theme.product_gallery.container && theme.product_gallery.slider){
				let container = theme.product_gallery.container.getBoundingClientRect(),
					slider = theme.product_gallery.slider.getBoundingClientRect(),
					delta = 0;
				if( container.bottom - window.innerHeight < 0 ){
					delta = container.bottom - window.innerHeight;
				}
				theme.product_gallery.slider.style.top = theme.scroll + delta + 'px';
			}
		}
	},

	product_dropdown: {
		items: undefined,
		submit: undefined,

		init: () => {
			theme.product_dropdown.items = document.querySelectorAll('.product-form__variants li');
			theme.product_dropdown.submit = document.querySelectorAll('.product-form__submit');

			if(theme.product_dropdown.items){
				theme.product_dropdown.items.forEach(item => {
					item.addEventListener('click', event => {
						theme.product_dropdown.submit.forEach(submit => {
							submit.classList.remove('product-form__submit--show');
						});
						let id = item.getAttribute('data-value');
						document.querySelector('[data-add-to-cart="'+id+'"]').classList.add('product-form__submit--show');
					});
				});
			}
		}
	},

	product_form: {
		el: undefined,
		button: undefined,
		id: undefined,
		quantity: undefined,

		init: () => {
			theme.product_form.el = document.querySelector('.product-form');
			theme.product_form.button = document.querySelectorAll('[data-add-to-cart]');
			theme.product_form.id = document.querySelector('input[name="id"]');
			theme.product_form.quantity = document.querySelector('.product-form .quantity__input');

			if(theme.product_form.el){
				theme.product_form.el.addEventListener('submit', event => {
					event.preventDefault();
					theme.product_form.button.forEach(button => {
						button.classList.add('button--loading');
						if(button.closest('.product-form__submit').querySelector('.product-form__note--quantity')){
							button.closest('.product-form__submit').querySelector('.product-form__note--quantity').style.display = 'none';
						}
					});
					let data = {
					 'items': [{
					  'id': theme.product_form.id.value,
					  'quantity': theme.product_form.quantity.value
					  }]
					};
					fetch('/cart/add.js', {
					  method: 'POST',
					  headers: {
					    'Content-Type': 'application/json'
					  },
					  body: JSON.stringify(data)
					})
					.then(response => {
					  return response.json();
					})
					.then(cart => {
						theme.product_form.button.forEach(button => {
							button.classList.remove('button--loading');
						});
						if(cart.status){
							theme.product_form.el.querySelector('[data-quantity-error-id="'+theme.product_form.id.value+'"]').style.display = 'block';
						} else {
							fetch(window.location.href).then(response => response.text()).then(text => {
						    const html = document.createElement('div');
			          html.innerHTML = text;
			          const cartHtml = html.querySelector('.cart--drawer').innerHTML;
			          if(cartHtml) {
			            document.querySelector('.cart--drawer').innerHTML = cartHtml;
			          }
			          theme.quantity.bind(false);
			          theme.cart.bind();
			          theme.animations.wrap_buttons();
			          theme.cart.open();
			          theme.cart.update_counter(parseInt(document.querySelector('.cart--drawer [data-cart-total]').getAttribute('data-cart-total')));
						  })
						  .catch(e => {
						    console.error(e);
						  });
						}
					})
					.catch((error) => {
					  console.log(error);
					});
				});
			}
		}
	},

	product_description: {
		el: undefined,
		button_scroll: undefined,
		tab_link: undefined,
		tab_content: undefined,

		init: () => {
			theme.product_description.el = document.querySelectorAll('.product-description .container');
			theme.product_description.button_scroll = document.querySelector('[data-scroll-to-content]');
			theme.product_description.tab_link = document.querySelectorAll('.product-tabs__link');
			theme.product_description.tab_content = document.querySelectorAll('.product-tabs__content');

			if(theme.product_description.el){
				theme.product_description.el.forEach(text => {
					text.innerHTML = text.innerHTML.replaceAll('<p>&nbsp;</p>', '');
				});

				if(theme.product_description.button_scroll){
					theme.product_description.button_scroll.addEventListener('click', event => {
						window.scroll({ 
							top: document.querySelector('.product-main').offsetHeight, 
							behavior: 'smooth' 
						});
					});
				}
			} else {
				theme.product_description.button_scroll.remove();
			}

			if(theme.product_description.tab_link){
				theme.product_description.tab_link.forEach(tab_link => {
					tab_link.addEventListener('click', event => {
						event.preventDefault();
						var id = tab_link.getAttribute('data-open-tab');
						theme.product_description.tab_link.forEach(link => {
							if(link.getAttribute('data-open-tab') == id){
								if(matchMedia('only screen and (max-width: 639px)').matches){
									link.classList.toggle('product-tabs__link--active');
								} else {
									link.classList.add('product-tabs__link--active');
								}
							} else {
								link.classList.remove('product-tabs__link--active');
							}
						});
						theme.product_description.tab_content.forEach(tab => {
							if(tab.getAttribute('data-tab') == id){
								if(matchMedia('only screen and (max-width: 639px)').matches){
									tab.classList.toggle('product-tabs__content--active');
								} else {
									tab.classList.add('product-tabs__content--active');
								}
							} else {
								tab.classList.remove('product-tabs__content--active');
							}
						});
						setTimeout(() => {
							theme.product_gallery.onScroll();
						});
					});
				});
			}
		}
	},

	cart: {
		drawer: undefined,
		drawer_opened: false,
		list: undefined,
		empty: undefined,
		button_open: undefined,
		button_close: undefined,
		button_update: undefined,
		subtotal: undefined,
		counter: undefined,
		note: undefined,
		booking_banner: undefined,
		show_booking_banner: false,

		init: () => {
			theme.cart.counter = document.querySelector('.header [data-cart-count]');			
			theme.cart.note = document.querySelector('[data-order-note]');
			theme.cart.booking_banner = document.querySelector('.booking-banner');

			document.querySelector('body').addEventListener('click', event => {
				if(theme.cart.drawer_opened){
					theme.cart.close();
				}
			});

			if(theme.cart.note){
				theme.cart.note.addEventListener('blur', event => {
					window.localStorage.setItem('skinbyolga_cart_note', event.target.value);
				});

				if(window.localStorage.getItem('skinbyolga_cart_note')){
					theme.cart.note.value = window.localStorage.getItem('skinbyolga_cart_note');
				}
			}

			theme.cart.bind();
		},

		bind: () => {
			theme.cart.drawer = document.querySelector('.cart--drawer');
			theme.cart.list = document.querySelectorAll('[data-cart-items]');
			theme.cart.button_update = document.querySelectorAll('[data-cart-update]');
			theme.cart.total = document.querySelectorAll('[data-cart-price-total]');
			theme.cart.subtotal = document.querySelectorAll('[data-cart-price-subtotal]');
			theme.cart.empty = document.querySelectorAll('[data-cart-empty]');
			theme.cart.button_open = document.querySelectorAll('[data-cart-open]');
			theme.cart.button_close = document.querySelectorAll('[data-cart-close]');

			theme.cart.button_open.forEach(button => {
				button.addEventListener('click', event => {
					theme.search.close();
					theme.cart.open();
				});
			}); 

			theme.cart.button_close.forEach(button => {
				button.addEventListener('click', event => {
					theme.cart.close();
				});
			});

			theme.cart.button_update.forEach(button => {
				button.addEventListener('click', event => {
					event.preventDefault();
					let action = button.getAttribute('data-cart-update'),
							item = button.closest(".cart__item"),
							id = item.getAttribute('data-cart-item-id'),
							quantity = parseInt(item.querySelector('.quantity__input').value),
							line_price = item.querySelector('[data-line-price]'),
							inventory_policy = item.getAttribute('data-cart-item-inventory-policy'),
							inventory_management = item.getAttribute('data-cart-item-inventory-management'),
							inventory_quantity = parseInt(item.getAttribute('data-cart-item-inventory-quantity')),
							preorder = item.querySelector('.cart__product-preorder'),
							data = {updates: {}};
					theme.cart.show_booking_banner = false;
					data.updates[id] = quantity;

					if(action === 'remove'){
						data.updates[id] = 0;
						item.classList.add('cart__item--remove');
						theme.cart.show_booking_banner = false;
						setTimeout(() => {
							item.parentNode.removeChild(item);
						},400);
						setTimeout(() => {
							document.querySelectorAll('.cart__item').forEach(cart_item => {
								if(cart_item.getAttribute('data-cart-item-booking-banner') === 'true'){
									theme.cart.show_booking_banner = true;
								}
							});
							if(theme.cart.show_booking_banner){
								theme.cart.booking_banner.classList.add('booking-banner--show');
							} else {
								theme.cart.booking_banner.classList.remove('booking-banner--show');
							}
						},410);
					}

					fetch('/cart/update.js', {
					  method: 'POST',
					  headers: {
					    'Content-Type': 'application/json'
					  },
					  body: JSON.stringify(data)
					})
					.then(response => {
					  return response.json();
					})
					.then(cart => {
						//console.log(cart);
						let total = cart.total_price / 100,
								subtotal = cart.items_subtotal_price / 100;
						theme.cart.total.forEach(el => {
							el.innerHTML = theme.numberWithSpaces(total) + ' €';
						});
						theme.cart.subtotal.forEach(el => {
							el.innerHTML = theme.numberWithSpaces(total) + ' €';
						});
						theme.cart.draw(cart.item_count);
						theme.cart.update_counter(cart.item_count);
						cart.items.forEach(cart_item => {
							if(cart_item.id == id){
								if(line_price){
									line_price.innerHTML = theme.numberWithSpaces(cart_item.final_line_price / 100) + ' €';
								}
								if(inventory_policy == 'continue' && cart_item.quantity > inventory_quantity && inventory_management){
									preorder.classList.add('cart__product-preorder--show');
								} else {
									preorder.classList.remove('cart__product-preorder--show');
								}
							}			
						});
					})
					.catch((error) => {
					  console.log(error);
					});

				});
			});
		},

		update_counter: (count) => {
			theme.cart.counter.innerHTML = count;
			if(count > 0){
				theme.cart.counter.classList.add('header__button-count--show');
			} else {
				theme.cart.counter.classList.remove('header__button-count--show');
			}
		},

		draw: (count) => {
			theme.cart.list.forEach(container => {
				if(count > 0){
					container.classList.add('container--show');
				} else {
					container.classList.remove('container--show');
				}
			});

			theme.cart.empty.forEach(container => {
				if(count > 0){
					container.classList.remove('container--show');
				} else {
					container.classList.add('container--show');
				}
			});			
		},

		open: () => {
			if(theme.cart.drawer && !theme.cart.drawer_opened){
				theme.header.close();
				theme.body_scroll.disable();
				theme.cart.drawer.classList.add('cart--open');
				theme.header.el.classList.add('header--opened');
				theme.header.el.classList.add('header--no-transparent');
				theme.cart.button_open.forEach(button => {
					button.setAttribute('aria-expanded', true);
				}); 
				theme.cart.drawer_opened = true;
			}
		},

		close: () => {
			if(theme.cart.drawer && theme.cart.drawer_opened){
				theme.body_scroll.enable();
				theme.cart.drawer.classList.remove('cart--open');
				theme.header.el.classList.remove('header--opened');
				theme.header.el.classList.remove('header--no-transparent');
				theme.cart.button_open.forEach(button => {
					button.setAttribute('aria-expanded', false);
				}); 
				theme.cart.drawer_opened = false;
			}
		}
	},

	search: {
		form: undefined,
		input: undefined,
		button_open: undefined,
		button_close: undefined,

		init: () => {
			theme.search.form = document.querySelector('.header .search');
			theme.search.input = document.querySelector('.header .search__input');
			theme.search.button_open = document.querySelectorAll('[data-search-open]');
			theme.search.button_close = document.querySelectorAll('[data-search-close]');

			document.querySelector('body').addEventListener('click', event => {
				theme.search.close();
			});

			theme.search.button_open.forEach(button => {
				button.addEventListener('click', event => {
					theme.cart.close();
					theme.search.open();
					theme.search.input.focus();
				});
			}); 

			theme.search.button_close.forEach(button => {
				button.addEventListener('click', event => {
					theme.search.close();
				});
			});
		},

		open: () => {
			theme.header.close();
			theme.search.form.classList.add('search--open');
			theme.header.el.classList.add('header--no-transparent');
			theme.search.button_open.forEach(button => {
				button.setAttribute('aria-expanded', true);
			}); 
		},

		close: () => {
			theme.search.form.classList.remove('search--open');
			theme.header.el.classList.remove('header--no-transparent');
			theme.search.button_open.forEach(button => {
				button.setAttribute('aria-expanded', false);
			}); 
		}
	},

	contact: {
		map: undefined,

		init: () => {
			autosize(document.querySelectorAll('textarea'));

			if(document.querySelector('.form--contact')){
				new window.JustValidate('.form--contact', {
				  rules: {
			      email: {
		          required: true,
		          email: true
			      },
			      name: {
		          required: true,
		          minLength: 3,
		          maxLength: 100
			      },
			      message: {
		          required: true,
		          minLength: 10,
		          maxLength: 1000
			      },
			      checkbox: {
		          required: true
			      },
			    },
			    focusWrongField: true
				});
			}

			if(document.getElementById('map')){
				let coordinates = [-6.235870522966207, 53.32206620256168];
				mapboxgl.accessToken = 'pk.eyJ1IjoibXdpbGstbW9oaXRvIiwiYSI6ImNrdzBnNnpjbDFiYWUyd2xjemNjMzF4bXUifQ.BAR3gGOE-555iM7FZNs1Jg';
				let map = new mapboxgl.Map({
					container: 'map',
					zoom: 15,
					center: coordinates,
					style: 'mapbox://styles/mapbox/light-v10'
				});

				map.addControl(new mapboxgl.NavigationControl());

				map.on('wheel', event => {
					event.preventDefault();
				});

				// Add map pin
				const el = document.createElement('div');
				el.className = 'contact__pin';
				new mapboxgl.Marker(el).setLngLat(coordinates).addTo(map);
			}
		}
	},

	facials: {
		button: undefined,

		init: () => {
			theme.facials.button = document.querySelectorAll('[data-show-addons]');

			theme.facials.button.forEach(button => {
				button.addEventListener('click', event => {
					let expanded = (button.getAttribute('aria-expanded') == 'false') ? true : false,
							content = button.parentNode.previousElementSibling;
					button.setAttribute('aria-expanded', expanded);
					if(expanded){
						content.style.display = 'block';
					} else {
						content.style.display = 'none';
					}
				});
			});
		}
	},

	login: {
		login: undefined,
		recover: undefined,
		button_password: undefined,
		input_password: undefined,

		init: () => {
			theme.login.login = document.getElementById('login');
			theme.login.recover = document.getElementById('recover');
			theme.login.button_password = document.querySelectorAll('[data-toggle-password]');

			theme.login.button_password.forEach(button => {
				button.addEventListener('click', event => {
					let input = button.parentNode.querySelector('input');
					if(input.getAttribute('type') == 'password'){
						input.setAttribute('type', 'text');
						button.classList.add('form__view--active');
					} else {
						input.setAttribute('type', 'password');
						button.classList.remove('form__view--active');
					}
					input.focus();
				});			
			});

			if(document.querySelector('.form--login')){
				new window.JustValidate('.form--login', {
				  rules: {
			      email: {
		          required: true,
		          email: true
			      },
			      password: {
		          required: true,
		          password: false
			      }
			    },
			    focusWrongField: true
				});
			}

			theme.login.toggle_form();
			window.addEventListener("hashchange", theme.login.toggle_form, false);
		},

		toggle_form: () => {
			if(location.hash == '#login'){
				theme.login.login.style.display = 'block';
				theme.login.recover.style.display = 'none';
			}
			if(location.hash == '#recover'){
				theme.login.login.style.display = 'none';
				theme.login.recover.style.display = 'block';
			}
		}
	},

	register: {
		init: () => {
			if(document.querySelector('.form--register')){
				new window.JustValidate('.form--register', {
				  rules: {
			      email: {
		          required: true,
		          email: true
			      },
			      password: {
		          required: true,
		          password: false,
		          minLength: 6
			      },
			      firstname: {
		          required: true,
		          minLength: 3,
		          maxLength: 100
			      },
			      lastname: {
		          required: true,
		          minLength: 3,
		          maxLength: 100
			      },
			      phone: {
		          required: true,
		          phone: false,
		          minLength: 9,
		          maxLength: 100
			      },
			      date: {
		          required: true,
		          minLength: 10
			      },
			      question1: {
		          required: true,
		          minLength: 2
			      },
			      question2: {
		          required: true,
		          minLength: 2
			      },
			      question3: {
		          required: true,
		          minLength: 2
			      }
			    },
			    messages: {
			      question1: {
			        minLength: 'You need to answer this question'
			      },
			      question2: {
			        minLength: 'You need to answer this question'
			      },
			      question3: {
			        minLength: 'You need to answer this question'
			      }
			    },
			    focusWrongField: true
				});
			}
		
			document.querySelectorAll('form input[data-checkbox]').forEach(item => {
				let group = item.getAttribute('data-checkbox'),
						input = document.querySelector('form input[data-checkbox-group="'+group+'"]'),
						checkboxes = document.querySelectorAll('form input[data-checkbox="'+group+'"]');
				item.addEventListener('change', event => {
					let values = [];
					checkboxes.forEach(checkbox => {
						if(checkbox.checked){
							values.push(checkbox.value);
						}
					});
					if(values.length > 0){
						input.value = values.join(', ');
						input.nextElementSibling.style.display = 'none';
					} else {
						input.value = '-';
						input.nextElementSibling.style.display = 'block';
					}
				}); 
			});

			document.querySelectorAll('form [data-textarea-other]').forEach(item => {
				let id = item.getAttribute('data-textarea-other'),
						element = document.querySelector('form [data-textarea="'+id+'"]'),
						textarea = element.querySelector('textarea');
				item.addEventListener('change', event => {
					if(item.checked){
						element.classList.remove('form__textarea--hidden');
						textarea.setAttribute('required', true);
					} else {	
						element.classList.add('form__textarea--hidden');
						textarea.removeAttribute('required');
					}
				});
			});
		}
	},

	account: {
		update_address: undefined,
		new_address: undefined,
		button_address_add: undefined,
		button_address_cancel: undefined,
		country_select: undefined,

		init: () => {
			theme.account.update_address = document.querySelector('.account__address--update');
			theme.account.new_address = document.querySelector('.account__address--add');
			theme.account.button_address_add = document.querySelector('[data-add-address]');
	    theme.account.button_address_cancel = document.querySelector('[data-cancel-add-address]');
	    theme.account.country_select = document.querySelectorAll('[data-address-country-select]');

	    if(theme.account.button_address_add){
		    theme.account.button_address_add.addEventListener('click', event => {
		    	theme.account.update_address.style.display = 'none';
		    	theme.account.new_address.style.display = 'block';
		    	document.documentElement.scrollTop = document.querySelector('.account__frame').offsetTop - 80;
		    });
	    }

	    if(theme.account.button_address_cancel){
		    theme.account.button_address_cancel.addEventListener('click', event => {
		    	theme.account.update_address.style.display = 'block';
		    	theme.account.new_address.style.display = 'none';
		    });
	    }

	    theme.account.country_select.forEach(select => {
	    	if(select.getAttribute('data-default')){
	    		select.value = select.getAttribute('data-default');
	    	}
	    });


		}

	},

	wishlist: {
		counter: undefined,
		button: undefined,

		init: () => {
			theme.wishlist.counter = document.querySelector('.header__button .iWishCount');
			theme.wishlist.button = document.querySelector('[data-add-wishlist-to-cart]');

			observer = new MutationObserver(function(mutationsList, observer) {
				mutationsList.forEach(mutation => {
					if(parseInt(mutation.target.innerHTML) > 0){
						mutation.target.classList.add('header__button-count--show');
					} else {
						mutation.target.classList.remove('header__button-count--show');
					}
				});
			});
			observer.observe(theme.wishlist.counter, {
				characterData: false, 
				childList: true, 
				attributes: false
			});

			if(theme.wishlist.button){
				theme.wishlist.button.addEventListener('click', event => {
					theme.wishlist.button.classList.add('button--loading');
					let data = {
					 'items': []
					};

					document.querySelectorAll('.wishlist__grid .product-item').forEach(item => {
						data.items.push({
							id: item.getAttribute('data-product-id'),
					  	quantity: 1
						});
					});

					fetch('/cart/add.js', {
					  method: 'POST',
					  headers: {
					    'Content-Type': 'application/json'
					  },
					  body: JSON.stringify(data)
					})
					.then(response => {
					  return response.json();
					})
					.then(cart => {
						theme.wishlist.button.classList.remove('button--loading');
						fetch(window.location.href).then(response => response.text()).then(text => {
					    const html = document.createElement('div');
		          html.innerHTML = text;
		          const cartHtml = html.querySelector('.cart--drawer').innerHTML;
		          if(cartHtml) {
		            document.querySelector('.cart--drawer').innerHTML = cartHtml;
		          }
		          theme.quantity.bind(false);
		          theme.cart.bind();
		          theme.animations.wrap_buttons();
		          theme.cart.open();
		          theme.cart.update_counter(parseInt(document.querySelector('.cart--drawer [data-cart-total]').getAttribute('data-cart-total')));
					  })
					  .catch(e => {
					    console.error(e);
					  });
					})
					.catch((error) => {
					  console.log(error);
					});

				});
			}
		}
	},

	animations: {
		init: () => {
			document.querySelectorAll('.media--animate').forEach(i => {
        const observer = new IntersectionObserver((entries) => {
          theme.animations.callback(entries, observer, i);
        }, { 
        	threshold: 0.5 
        });    
	      
	      observer.observe(i);
			});

			theme.animations.wrap_buttons();
		},

		wrap_buttons: () => {
			document.querySelectorAll('.button__label').forEach(label => {
				if(!label.parentNode.querySelector('button__hover')){
					let hover = label.cloneNode(true);
					hover.classList.remove('button__label');
					hover.classList.add('button__hover');
					label.parentElement.appendChild(hover);
				}
			});
		},

		callback: (entries, observer, header) => {
			entries.forEach((entry, i) => {
      	if(entry.isIntersecting) {
       		entry.target.classList.add('media--animate-in');
				}
	    });
		}
	},

	body_scroll: {
		el: undefined,
		scroll: 0,

		init: () => {
			theme.body_scroll.el = document.querySelector('body');
		},

		enable: () => {
			theme.body_scroll.el.style.position = '';
			theme.body_scroll.el.style.maxWidth = '';
			theme.body_scroll.el.style.top = '';
			document.documentElement.scrollTop = theme.body_scroll.scroll;
			theme.body_scroll.scroll = 0;
			theme.scroll_disabled = false;
		},

		disable: () => {
			theme.scroll_disabled = true;
			theme.body_scroll.scroll = theme.scroll;
			theme.body_scroll.el.style.maxWidth = theme.body_scroll.el.clientWidth + 'px';
			theme.body_scroll.el.style.position = 'fixed';;
			theme.body_scroll.el.style.top = -theme.scroll + 'px';
		}
	},

	numberWithSpaces: x => {
		x = parseFloat(x);
    var parts = x.toString().split(".");
    if(parts[1]){
    	x = x.toFixed(2);
    	parts = x.toString().split(".");
    }
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    return parts.join(",");
	},

	onScroll: () => {
		let scroll = window.pageYOffset || document.documentElement.scrollTop;
	  if(scroll >= theme.scroll){
	  	theme.scroll_direction = 'down';
	  } else {
	  	theme.scroll_direction = 'up';
	  }
   	theme.scroll = scroll <= 0 ? 0 : scroll; 

   	if(!theme.scroll_disabled){
   		theme.header.onScroll();
   		theme.product_gallery.onScroll();
   	}
	},

	onResize: () => {
		theme.recommendations.resize();
	}
}

document.addEventListener("DOMContentLoaded", () => {
	theme.init();

	window.addEventListener("scroll", theme.onScroll);
	window.addEventListener("resize", theme.onResize);
	window.dispatchEvent(new Event("scroll"));
	window.dispatchEvent(new Event("resize"));
});